import { FC, useState } from 'react'
import { Modal, PrimaryButton, LoadingContainer } from '../../../ui'
import { Checkbox, Typography } from 'antd'
import { Link, useNavigate } from 'react-router-dom'
import {useGetTariffRate, useGetUserTariffRate} from '../../../hooks'
import useRequest, { RequestTypes } from '../../../hooks/useRequest'
import style from './style.m.less'
import moment from 'moment'
import {useCurrentUser} from "../../../hooks/useCurrentUser";
import {EUserRole} from "../../../../constants/profile";

interface IProlongPaymentModal {
    isModalVisible: boolean
    onCancel: () => void
    deleteTitle?: string
    cancelTitle?: string
    goName?: string
    id?: string
    tsPayed?: string
    ownerId?: string
}

const ProlongPaymentModal: FC<IProlongPaymentModal> = ({
    isModalVisible,
    onCancel,
    goName,
    id,
    deleteTitle = 'Оплатить',
    cancelTitle = 'Отмена',
    tsPayed,
    ownerId
}) => {
    const [checked, setIsChecked] = useState(false)
    const navigate = useNavigate()
    const { isUserAdmin } = useCurrentUser()

    const { fetch, isLoading } = useRequest({
        link: `/api/generators/v1/go-prolong?generator_id=${id}`,
        method: RequestTypes.get,
    })

    const onConfirm = () => {
        fetch({
            successMessage: {
                title: 'Успешно',
                description: `ЗГО ${goName} успешно оплачен`,
            },
            onSuccess: () => navigate('/generators/Active'),
//            onSuccess: () => navigate('/my-generators/Active'),
            errorCodeMessage: true,
        })
    }

    const { loadingTariffs, balance, rate } = isUserAdmin
        ? useGetUserTariffRate({
            dependency: isModalVisible,
            id: 71,
            tsPayed: moment(tsPayed).unix(),
            userId: ownerId,
            userRole: EUserRole.GOOwner
        })
        : useGetTariffRate({
            dependency: isModalVisible,
            id: 71,
            tsPayed: moment(tsPayed).unix(),
        })

    const onChange = (e: any) => {
        setIsChecked(e.target.checked)
    }

    return (
        <LoadingContainer isLoading={loadingTariffs || isLoading}>
            <Modal isModalVisible={isModalVisible} onCancel={onCancel}>
                <div className={style.modal}>
                    <div className={style.modalWrapper}>
                        <div className={style.header}>{'Оплата комиссии'}</div>
                    </div>
                    <Checkbox checked={checked} className={style.checkbox} onClick={onChange}>
                        {`Согласен оплатить услуги Системы по подтверждению статуса ГО ${goName}`}
                    </Checkbox>
                    <div className={style.payAlert}>
                        <div className={style.payHeader}>
                            <span className={style.alertMessage}>Сумма комиссии составила </span>
                            <span className={style.alertPrice}>{rate}</span>
                        </div>
                        <div className={style.payText}>
                            <span className={style.alertDetail}>Баланс платежного счета</span>
                            <span className={style.alertDetail}> {balance}</span>
                        </div>
                    </div>
                    <div className={style.buttonsBlock}>
                        <PrimaryButton
                            onClick={onCancel}
                            value={cancelTitle}
                            isCancel
                            customStyle={{padding: '8px 16px'}}
                        />
                        <PrimaryButton
                            onClick={onConfirm}
                            disabled={!checked}
                            value={deleteTitle}
                            customStyle={{marginLeft: '16px', padding: '8px 16px'}}
                        />
                    </div>
                </div>
            </Modal>
        </LoadingContainer>
)
}

export default ProlongPaymentModal
